/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable unicorn/no-null */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useVisibilityTester from '@/pages/VisibilityTester/hooks/useVisibilityTester';

function VisibilityTester() {
  const [isTracking, setIsTracking] = useState(false);
  const { metrics, startTracking, stopTracking, resetTracking } = useVisibilityTester(
    isTracking,
    2000,
  );
  const toggleTracking = () => {
    setIsTracking((previous) => {
      if (previous) stopTracking();
      else startTracking();
      return !previous;
    });
  };

  const reset = () => {
    setIsTracking(false);
    resetTracking();
  };
  const { t } = useTranslation();

  return (
    <div>
      <button type="submit" onClick={toggleTracking}>
        {isTracking ? `${t('stopTracking')}` : `${t('startTracking')}`}
      </button>
      <button type="submit" onClick={reset}>
        {t('reset')}
      </button>
      <h3>{t('visibleLogs')}</h3>
      <pre>{JSON.stringify(metrics, null, 2)}</pre>
    </div>
  );
}
export default VisibilityTester;
